module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.component) ? _c(_vm.component, {
    tag: "component"
  }) : _c('div', {
    staticClass: "landing",
    domProps: {
      "innerHTML": _vm._s(_vm.html)
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-52ef9498"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Landing.vue
// module id = 102
// module chunks = 0